export const ACTION_LIST_URL        = 'action/list'
export const ACTION_LIST_URL_MODULES        = 'action/list_modules'
export const ACTION_LIST_ERROR      = 'ACTION_LIST_ERROR'
export const ACTION_LIST_LOADING    = 'ACTION_LIST_LOADING'
export const ACTION_LIST_SUCCESS    = 'ACTION_LIST_SUCCESS'

export const ACTION_PAGE_URL        = 'action/page'
export const ACTION_PAGE_ERROR      = 'ACTION_PAGE_ERROR'
export const ACTION_PAGE_LOADING    = 'ACTION_PAGE_LOADING'
export const ACTION_PAGE_SUCCESS    = 'ACTION_PAGE_SUCCESS'

export const ACTION_VIEW_URL        = 'action/view'
export const ACTION_VIEW_ERROR      = 'ACTION_VIEW_ERROR'
export const ACTION_VIEW_LOADING    = 'ACTION_VIEW_LOADING'
export const ACTION_VIEW_SUCCESS    = 'ACTION_VIEW_SUCCESS'

export const ACTION_SET_URL        = 'action/set'
export const ACTION_SET_ERROR      = 'ACTION_SET_ERROR'
export const ACTION_SET_LOADING    = 'ACTION_SET_LOADING'
export const ACTION_SET_SUCCESS    = 'ACTION_SET_SUCCESS'